import merge from "lodash/merge";

import actions from "../../constants/actions";

const initialState = {
    data: [],
    tags: [],
    related: [],
    isLoading: false,
    pagination: null,
    errorMessage: "",
};

export default function blog(state = initialState, action) {
    let pagination = null;

    switch (action.type) {
        case actions.BLOG.LOAD_LIST:
            return { ...state, isLoading: true };
        case actions.BLOG.LOAD_LIST_SUCCESS:
            if (action.payload.result.meta) {
                pagination = action.payload.result.meta;
                if (action.payload.result.meta.current_page === 1)
                    state.data = [];
            }

            return merge({}, state, {
                data: state.data.concat(action.payload.result.data),
                pagination,
                isLoading: false,
                errorMessage: "",
            });
        case actions.BLOG.LOAD_LIST_FAIL:
            return { ...state, isLoading: false, errorMessage: action.payload };

        case actions.BLOG.LOAD_TAGS:
            return { ...state, isLoading: true };
        case actions.BLOG.LOAD_TAGS_SUCCESS:
            return {
                ...state,
                tags: action.payload.data,
                isLoading: false,
                errorMessage: null,
            };
        case actions.BLOG.LOAD_TAGS_FAIL:
            return {
                ...state,
                isLoading: false,
                errorMessage: action.payload,
            };

        case actions.BLOG.LOAD_RELATED:
            return { ...state, isLoading: true };
        case actions.BLOG.LOAD_RELATED_SUCCESS:
            return {
                ...state,
                related: action.payload.result.data,
                isLoading: false,
                errorMessage: null,
            };
        case actions.BLOG.LOAD_RELATED_FAIL:
            return { ...state, isLoading: false, errorMessage: action.payload };

        default:
            return state;
    }
}
